<template>
	<div>
		<top-header></top-header>
		<div class="white-box">
			<navi></navi>
		</div>
		<div class="flex-box center-width mt30">
			<nav class="article-nav">
				<ul class="nav-list">
					<li v-for="(item, idx) in navList" :key="idx" :class="item.className" @click="toggleArticleType(item.type)">{{item.name}}</li>
				</ul>
			</nav>
			<div class="article-box">
		    <!--标题列表-->
		    <div class="article-title" v-if="isTitle">
		    	<div class="top">
		    		<span class="title-type" :class="iconClass">{{titleName}}</span>
		    		<div class="search right">
							<input @keyup.enter="searchTitle" type="text" placeholder="搜索标题" v-model="searchContent"/>
							<button @click="searchTitle">搜索</button>
						</div>
		    	</div>
		    	<div class="none-tip" v-if="noneTitle">该分类下暂无文章</div>
		    	<!--专稿要闻样式独立-->
		    	<ul class="title-list" v-loading="showLoading" v-if="type=='10303_1_2'">
		    		<li v-for="(item, idx) in titleList" class="img-li" :key="idx">
		    			<div class="title-content">
		    				<h2 @click="goToDetail(item.id)" v-html="item.informationContent"></h2>
		    				<p class="news-content" v-html="item.informationContent"></p>
		    				<span class="date">{{dateFilter(item.createDate,2)}}</span>
		    				<span class="views" v-if="item.pageViews">{{item.pageViews}} 浏览</span>
		    			</div>
		    		</li>
		    	</ul>
		    	<ul class="title-list" v-loading="showLoading" v-else>
		    		<li v-for="(item, idx) in titleList" class="word-li" :key="idx">
		    			<h2 @click="goToDetail(item.id)" v-html="item.informationTitle"></h2>
		    			<span class="date">{{dateFilter(item.createDate,2)}}</span>
		    		</li>
		    	</ul>
		    	<el-pagination class="right"
			      :page-size.sync="pageSize" :page-sizes="[10,15,20,30]"  :current-page.sync="currentPage"
			      layout="total, sizes, prev, pager, next, jumper" v-if="totalElements>10"
			      :total="totalElements"  @current-change="searchTitle" @size-change="sizeChange">
			    </el-pagination>
		    </div>
		    <!--文章详情-->
		    <div class="article-detail" v-if="isDetail" v-loading="showLoading">
		    	<button class="go-back" @click="toggleArticleType(type)"></button>
		    	<h1 class="detail-title" v-html="detailObj.informationTitle"></h1>
		    	<div class="article-info">
		    		<span>更新时间 : {{dateFilter(detailObj.lastUpdateDate,2)}}</span>
		    		<span v-if="detailObj.informationIssuer">来源 : {{detailObj.informationIssuer}}</span>
		    		<!-- <span>{{detailObj.pageViews}} 浏览</span> -->
		    	</div>
		    	<div v-html="detailObj.informationContent" class="article-content"></div>
		    	<!-- <div class="file" v-if="detailObj.attachMentInfoVoList&&detailObj.attachMentInfoVoList.length>0">
		    		<p>附件下载：</p>
		    		<p v-for="(file, idx) in detailObj.attachMentInfoVoList" :key="idx"><a :href="file.url">{{file.originName}}</a></p>
		    	</div> -->
		    </div>
	    	<div class="article-arrow" v-if="isDetail">
	    		<a v-if="detailObj.preNoticeId" @click="goToDetail(detailObj.preNoticeId)">上一篇：{{detailObj.preNoticeTitle}}</a>
	    		<a class="right" v-if="detailObj.nextNoticeId" @click="goToDetail(detailObj.nextNoticeId)">下一篇：{{detailObj.nextNoticeTitle}}</a>
	    	</div>
			</div>
		</div>

		<foot></foot>
		<copyright></copyright>
	</div>
</template>

<script>
	import $ from 'jquery'
	import topHeader from '../../components/common/header.vue'
	import navi from '../../components/common/nav.vue'
	import foot from '../../components/common/footer.vue'
	import copyright from '../../components/common/copyright.vue'

	export default {
		data() {
		  return {
		  	totalElements:0,
		  	currentPage: 1,
				pageSize:10,
				//url是否是带文章id打开本页面
				detailFirst:false,
				//文章搜索关键字
				searchContent:'',
				showLoading:false,
		  	isTitle:true,
		  	isDetail:false,
		  	//没有文章时显示
		  	noneTitle:false,
		  	//文章分类请求字段
		  	type:'10303_1_1',
		  	//文章标题集
		  	titleList:[],
		  	//文章分类
		  	titleName:'市场公告',
		  	//文章分类icon
		  	iconClass:'t_scgg',
		  	//文章详情
		  	detailObj:{},
		  	navList:[
		  		{name:'市场公告',type:'10303_1_1',className:'',iconName:'t_scgg'},
		  		{name:'行业快讯',type:'10303_1_2',className:'',iconName:'t_zgyw'},
		  	]
		  };
		},
		created(){
			this.handleUrlParam();
		},
		mounted(){
		},
		methods: {
			toggleArticleType(type){//左边导航栏点击切换
				var vm = this;
				history.pushState(null,document.title,location.href.split("?")[0]);
				vm.searchContent = '';
				vm.navList.forEach(function(e){
					if(e.type===type){
						e.className = 'active';
						vm.titleName = e.name;
						vm.iconClass = e.iconName;
						vm.type = e.type;
						vm.searchTitle();
						document.title = e.name;
						vm.setMeta(document.title,document.title)
					}else {
						e.className = '';
					}
				})
			},
			handleUrlParam(){//url带有type或者文章id时处理
				var vm = this;
				if(vm.urlParam.getUrlKey('id')){
					vm.detailFirst = true;
					vm.goToDetail(vm.urlParam.getUrlKey('id'));
				}else if(vm.urlParam.getUrlKey('type')){
					vm.type = vm.urlParam.getUrlKey('type');
					vm.setActive();
					vm.searchTitle();
				}else {//直接打开时
					vm.setActive();
					vm.searchTitle();
				}
			},
			setActive(){//初始化导航栏状态
				var vm = this;
				vm.navList.forEach(function(e){
					if(e.type===vm.type){
						e.className = 'active';
						vm.titleName = e.name;
						document.title = e.name;//分类的title覆盖了文章的
						vm.iconClass = e.iconName;
					}else {
						e.className = '';
					}
				})
			},
			initArticle(){
				var vm = this;
				vm.showLoading = true;
				let params = {
          api: vm.urls.article.article,
		  		data: {
		  			pageSize:8,
		  			categoryNo: this.type,
            orgNo:'10303',
            currentNo: 1
		  		}
		  	};
		  	vm.api.post(params).then((res) => {
	  			var data = (typeof res.data=='string')?JSON.parse(res.data):res.data;
	  			if(data.succeed){
	  				vm.showLoading = false;
	  				if(data.data.rows){
	  					vm.totalElements = data.data.totalElements;
	  					vm.titleList = data.data.rows;
	  					if(vm.titleList.length==0){
	  						vm.noneTitle = true;
	  					}
	  					vm.isTitle = true;
	  					vm.isDetail = false;
	  				}
	  			}else{
	  				vm.showLoading = false;
	  				vm.$message.error("加载文章列表失败:"+data.errorMsg);
	  			}
	  		})
			},
			searchTitle(page){
				var vm = this;
				vm.showLoading = true;
				let params = {
          api: vm.urls.article.article,
		  		data: {
		  			pageSize:8,
		  			categoryNo: this.type,
            orgNo:'10303',
            currentNo: page || 1,
            informationTitle: this.searchContent || ''
		  		}
		  	};
		  	vm.api.post(params).then((res) => {
	  			var data = (typeof res.data=='string')?JSON.parse(res.data):res.data;
	  			if(data.succeed){
	  				vm.showLoading = false;
	  				vm.titleList = data.data.rows;
	  				vm.totalElements = data.data.totalElements;
	  				if(vm.titleList.length==0){
  						vm.noneTitle = true;
  					}else {
  						vm.noneTitle = false;
  					}
  					vm.isTitle = true;
  					vm.isDetail = false;
	  			}else{
	  				vm.showLoading = false;
	  				vm.$message.error("搜索文章失败:"+data.errorMsg);
	  			}
	  		});
			},
			goToDetail(id){
				var vm = this;
				//vm.detailObj={};//点上一篇时造成页面闪现
				vm.showLoading = true;
				let params = {
		  		api: vm.urls.article.detail,
		  		data: {
		  			id:id,
		  		}
		  	};
		  	vm.api.post(params).then((res) => {
	  			var data = (typeof res.data=='string')?JSON.parse(res.data):res.data;
	  			if(data.succeed){
	  				vm.isTitle = false;
						vm.isDetail = true;
	  				vm.showLoading = false;
	  				vm.detailObj = data.data;
	  				//查询成功后给url带上文章id
	  				history.pushState(null,document.title,location.href.split("?")[0]+"?id="+id);
	  				setTimeout(function(){
	  					document.title = vm.detailObj.informationTitle;
	  					vm.setMeta(vm.detailObj.informationTitle,vm.detailObj.informationSummary||vm.detailObj.informationTitle);
    				},0);
	  				// if(vm.detailFirst){//如果带id跳转到本页，先查询详情后再初始化左侧导航
	  				// 	vm.type = data.data.msgType.toString();
	  				// 	vm.setActive();
	  				// };
	  			}else if(data.errorCode=="300004"){
	  				location.href = "errorPage.html"
	  			}else{
	  				vm.showLoading = false;
	  				vm.$message.error("加载文章详情失败:"+data.errorMsg);
	  			}
	  		});
  		},
  		removeHtmlTag(str) {
        str = str.replace(/<\/?[^>]*>/g,''); //去除HTML tag
        str = str.replace(/[ | ]*\n/g,'\n'); //去除行尾空白
        str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
        str = str.replace(/&nbsp;/ig,'');//去掉&nbsp;
        str = str.replace(/\s/g,''); //将空格去掉
        return str;
			},
			setMeta(keywords,description){
				let metas = document.getElementsByTagName("meta");
				for(let meta of metas){
					if(meta.name==="keywords"){
						meta.content=keywords+'-茧丝交易网'
					}else if(meta.name==="description"){
						meta.content=description+'-茧丝交易网'
					}
				}
			},
  		sizeChange(size) {//页容量变化
	 	 		this.pageSize = size;
	  		this.searchTitle();
	  	},
		},
		components:{
			topHeader,
			foot,
			navi,
			copyright
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import '../../assets/css/reset.css'
  @import '../../assets/css/common.css'
  @import '../../assets/css/stylus/article.styl'
  [v-cloak] {
    display: none;
  }
  .go-back {
  	position: absolute;
  	top: 18px;
  	width: 32px;
		height: 32px;
		border-radius: 2px;
		background-color: #fff;
		border: solid 1px #909090;
		background-image: url(../../assets/images/common/back_nor.png);
		background-repeat: no-repeat;
		background-position: 9px center;
  }
</style>



// WEBPACK FOOTER //
// Article.vue?1d7f84ae